import { type FC } from 'react'

import { useGlobalConfigContext } from '../../../../global-config'
import { priceGetFormattedPercentageDiscount } from '../../../../price'
import { ProductDiscount, useProductConfigContext } from '../../../../product'
import { productSearchAlgoliaAccessorGetDiscountData } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetDiscountData'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'

type ProductSearchResultItemPriceContainerDiscountBadgeProps = {
  showBpcReferencePrice: boolean
}

export const ProductSearchResultItemPriceContainerDiscountBadge: FC<
  ProductSearchResultItemPriceContainerDiscountBadgeProps
> = ({ showBpcReferencePrice }) => {
  const { algoliaRecord: item } = useProductSearchResultItemContext()
  const { tenant } = useGlobalConfigContext()
  const { discountBoundaries } = useProductConfigContext()

  const { discountInPercent, showDiscount } =
    productSearchAlgoliaAccessorGetDiscountData(
      item,
      discountBoundaries,
      tenant,
    )

  return showDiscount ? (
    <ProductDiscount className="text-xs">
      {priceGetFormattedPercentageDiscount(discountInPercent)}
      {showBpcReferencePrice ? '*' : null}
    </ProductDiscount>
  ) : null
}
